/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do I get an error when decoding binary?`)
};

const es_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué recibo un error al decodificar binario?`)
};

const de_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum erhalte ich beim Dekodieren von Binärcode einen Fehler?`)
};

const nl_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom krijg ik een fout wanneer ik binair decodeer?`)
};

const fr_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi je reçois une erreur lors du décodage du binaire?`)
};

const it_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché ricevo un errore quando decodifico il binario?`)
};

const pt_br2_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que recebo um erro ao decodificar binário?`)
};

const pt_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que recebo um erro ao descodificar binário?`)
};

const ja_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイナリをデコードするときにエラーが表示されるのはなぜですか?`)
};

const zh_tb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么解码二进制时会出现错误?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq4_q", locale)
	if (locale === "en") return en_tb_faq4_q(inputs)
	if (locale === "es") return es_tb_faq4_q(inputs)
	if (locale === "de") return de_tb_faq4_q(inputs)
	if (locale === "nl") return nl_tb_faq4_q(inputs)
	if (locale === "fr") return fr_tb_faq4_q(inputs)
	if (locale === "it") return it_tb_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq4_q(inputs)
	if (locale === "pt") return pt_tb_faq4_q(inputs)
	if (locale === "ja") return ja_tb_faq4_q(inputs)
	return zh_tb_faq4_q(inputs)
};